import { render, staticRenderFns } from "./LogoImage.vue?vue&type=template&id=35ce6e3a&scoped=true&"
import script from "./LogoImage.vue?vue&type=script&lang=js&"
export * from "./LogoImage.vue?vue&type=script&lang=js&"
import style0 from "./LogoImage.vue?vue&type=style&index=0&id=35ce6e3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce6e3a",
  null
  
)

export default component.exports